export {
  getFranchisePageBySlug,
  getFranchiseBySlug,
  buildSubtitle,
  canStreamEpisode,
  getLightFranchiseBySlug,
} from './FranchiseService'
export type { FranchisePageData, LightFranchise, FranchiseExtended } from './FranchiseService'
